import React, { useState } from 'react'

import { Button, Textarea } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

function DirectLinkCopyRow({ url = '' }) {
  const [isCopying, setIsCopying] = useState(false)
  const resolvedUrl = url || window.location.href

  return (
    <div className="share-modal__input-wrapper">
      <span className="share-modal__input-label">
        Or copy direct link below
      </span>
      <div className="share-modal__input-container">
        <Textarea
          id="link-input"
          isPilot
          readOnly
          wrapperClassName="share-modal__input"
          value={resolvedUrl}
          rows={2}
          size="tiny"
        />
        <Button
          customClass="share-modal__copy-button"
          onClick={() => {
            setIsCopying(true)
            navigator.clipboard.writeText(resolvedUrl)
            setTimeout(() => setIsCopying(false), 1000)
          }}
          size="small"
        >
          {isCopying ? 'Copied!' : 'Copy'}
        </Button>
      </div>
    </div>
  )
}

DirectLinkCopyRow.propTypes = {
  url: string,
}

export default DirectLinkCopyRow
